import { render, staticRenderFns } from "./PrivacyVue.vue?vue&type=template&id=6a3c9654&scoped=true"
import script from "./PrivacyVue.vue?vue&type=script&lang=js"
export * from "./PrivacyVue.vue?vue&type=script&lang=js"
import style0 from "./PrivacyVue.vue?vue&type=style&index=0&id=6a3c9654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3c9654",
  null
  
)

export default component.exports